/* eslint-disable */
import { lazy } from 'react';
import { USER_ROLE } from 'constants.js';
import { DEFAULT_PATHS } from 'config.js';
import { components } from 'react-select/dist/index-ea9e225d.cjs.prod';
import Shortlisted from 'views/Profile/Shortlisted/Shortlisted';


// const blog = lazy(() => import('views/blog/Blog'));
// const community = {
//   index: lazy(() => import('views/community/Community')),
//   list: lazy(() => import('views/community/CommunityList')),
// };
// const upgrade = lazy(() => import('views/upgrade/Upgrade'));

const dashboard = {
  gettingStarted: lazy(() => import('views/dashboard/DashboardGettingStarted')),
  analysis: lazy(() => import('views/dashboard/DashboardAnalysis')),
};

const shortlist = lazy(() => import('views/Shortlist/Shortlist'))

const shortlisted = lazy(() => import('views/Profile/Shortlisted/Shortlisted'))
const Inteview = lazy(() => import('views/AiScreeningInterviewAssignment/Interview/Interview'))

const Profile = lazy(() => import('views/Profile/Profile'))
const Communication = lazy(() => import('views/AiScreeningInterviewAssignment/Communication/Communication'))
const AnalysisProfile = lazy(() => import('views/AiScreeningInterviewAssignment/Analysis/Analysis'))
const AnalyzedProfiles = lazy(() => import('views/AiScreeningInterviewAssignment/AnalyzedProfiles/analyzedProfiles'))

const Report = lazy(() => import('views/AiScreeningInterviewAssignment/Interview/Report'))

const VideoTranscriber = lazy(() => import('views/AiScreeningInterviewAssignment/Interview/VideoTranscriber'))
// Adminviews
// const Organization=lazy(()=>import('Adminviews/Organization/Organization'))
// const Recruiter=lazy(()=>import('Adminviews/Recruiter/Recruiter'))
// const Recruiterview=lazy(()=>import('Adminviews/Recruiter/Recruiterview'))
// const Integration=lazy(()=>import('Adminviews/Integration/Integration'))
// const OrganizationView=lazy(()=>import('Adminviews/Organization/Organizationview'))

const Communication1 = lazy(() => import('views/AiScreeningInterviewAssignment/Communication/UnMatchedCommunication1'))
const UploadResume = lazy(() => import('views/AiScreeningInterviewAssignment/UploadResume/UploadResume'))
const analysisstaffing = lazy(() => import('views/Totalstaffing/staffingproject'))
const Staffingview = lazy(() => import('views/Totalstaffing/StaffingView'))
const InterviewScreen = lazy(() => import('views/Candidate/index'))
const Scheduleinterview = lazy(() => import('views/Schedule/scheduleinterview'))
const SchedulelistHandle = lazy(() => import('views/Schedule/schedulelist'))
const Interviewprofilelist = lazy(() => import('views/AiScreeningInterviewAssignment/Interview/interviewprofilelist'))
const ReadytoscheduleList = lazy(() => import('views/Schedule/Readytoschedule/readytoschedulelist'))
const Conforminterview = lazy(() => import('views/Schedule/conforminterview/conforminterview'))
const Applicationcompleted = lazy(() => import('views/Schedule/applicationcomplete/complete'))
const konbonDasborad = lazy(() => import('views/dashboard/konbondashboard/dashbord'))
const Accountdetails = lazy(() => import('views/Accountdetails/index'))
// const services = {
//   database: lazy(() => import('views/services/ServicesDatabase')),
//   databaseAdd: lazy(() => import('views/services/ServicesDatabaseAdd')),
//   databaseDetail: lazy(() => import('views/services/ServicesDatabaseDetail')),
//   storage: lazy(() => import('views/services/ServicesStorage')),
//   storageFolder: lazy(() => import('views/services/ServicesStorageFolder')),
//   hosting: lazy(() => import('views/services/ServicesHosting')),
//   users: lazy(() => import('views/services/ServicesUsers')),
// };
// const account = {
//   settings: lazy(() => import('views/account/AccountSettings')),
//   billing: lazy(() => import('views/account/AccountBilling')),
//   security: lazy(() => import('views/account/AccountSecurity')),
// };
// const support = {
//   docs: lazy(() => import('views/support/SupportDocs')),
//   docsDetail: lazy(() => import('views/support/SupportDocsDetail')),
//   knowledgeBase: lazy(() => import('views/support/SupportKnowledgeBase')),
//   tickets: lazy(() => import('views/support/SupportTickets')),
//   ticketsDetail: lazy(() => import('views/support/SupportTicketsDetail')),
// };

const appRoot = DEFAULT_PATHS.APP.endsWith('/') ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length) : DEFAULT_PATHS.APP;

const routesAndMenuItems = {
  mainMenuItems: [
    {
      path: DEFAULT_PATHS.APP,
      exact: true,
      redirect: true,
      to: `${appRoot}/login`,
    },
    // {
    //   path: `${appRoot}/blog`,
    //   component: blog,
    //   label: 'menu.blog',
    //   icon: 'file-text',
    // },
    // {
    //   path: `${appRoot}/upgrade`,
    //   label: 'menu.upgrade',
    //   icon: 'trend-up',
    //   component: upgrade,
    // },
    // {
    //   path: `${appRoot}/community`,
    //   label: 'menu.community',
    //   icon: 'messages',
    //   component: community.index,
    //   subs: [
    //     {
    //       path: '/list',
    //       label: 'menu.community-list',
    //       hideInMenu: true,
    //       component: community.list,
    //     },
    //   ],
    // },
  ],
  sidebarItems: [
    // {
    //   path: `${appRoot}/dashboard`,
    //   label: 'menu.dashboard',
    //   icon: 'grid-1',
    //   exact: true,
    //   redirect: true,
    //   to: `${appRoot}/dashboard/getting-started`,
    //   subs: [
    //     { path: '/getting-started', label: 'Dashboard', icon: 'navigate-diagonal', component: dashboard.gettingStarted },
    //     // { path: '/analysis', label: 'menu.analysis', icon: 'chart-4', component: dashboard.analysis },
    //   ],
    // },
    {
      path: `${appRoot}/dashboard`,
      label: 'Dashboard',
      icon: "home",
      component: dashboard.gettingStarted
    },
    {
      path: `${appRoot}/staffing`,
      label: "Job Campaign",
      icon: "file-text",
      component: analysisstaffing,

    },
    {
      path: `${appRoot}/ai-screening`,
      label: "AI Screening",
      icon: "grid-1",
      component: UploadResume,
    },
    {
      path: `${appRoot}/analysis`,
      // label: "Analysis Profiles",
      icon: "grid-1",
      component: AnalysisProfile,


    },
    {
      path: `${appRoot}/analyzed_profiles`,
      // label: "Analysis Profiles",
      // icon: "grid-1",
      component: AnalyzedProfiles,


    },
    {
      path: `${appRoot}/communication`,
      // label: "Communication",
      icon: "grid-1",
      component: Communication,
    },
    {
      path: `${appRoot}/unmatchedcommunication`,
      // label: "Communication1",
      icon: "grid-1",
      component: Communication1,
    },

    {
      path: `${appRoot}/interview`,
      // label: "Interview",
      icon: "grid-1",
      component: Inteview,
    },

    {
      path: `${appRoot}/shortlist`,
      label: "Shortlist",
      icon: "list",
      component: shortlist,

    },
    {
      path: `${appRoot}/staffingview`,
      // label: "Staffing_View",
      icon: "grid-1",
      component: Staffingview,


    },
    {
      path: `${appRoot}/candidate/:uuid/:scheduleId/:interviewid`,
      // label:"Staffing_Project",
      icon: "grid-1",
      component: InterviewScreen,

    },
    {
      path: `${appRoot}/Readytoschedule`,
      label: "Schedule",
      icon: "grid-1",
      component: ReadytoscheduleList,
    },
    {
      path: `${appRoot}/Scheduleinterview/:id/:clsId/:job`,
      // label: "Schedule",
      icon: "calendar",
      component: Scheduleinterview,
    },

    {
      path: `${appRoot}/schedulelist`,
      // label:"Staffing_Project",
      icon: "grid-1",
      component: SchedulelistHandle,
    },
    {
      path: `${appRoot}/interview_profilelist`,
      // label:"Staffing_Project",
      icon: "grid-1",
      component: Interviewprofilelist,
    },
    {
      path: `${appRoot}/Readytoschedule`,
      // label:"Staffing_Project",
      icon: "grid-1",
      component: ReadytoscheduleList,
    },
    {
      path: `${appRoot}/confirm_interview/:candidate/:clsId/:interviewuuid`,
      // label:"Staffing_Project",
      icon: "grid-1",
      component: Conforminterview,
    },
    {
      path: `${appRoot}/application_complete/:id/:clsId/:interviewid`,
      // label:"Staffing_Project",
      icon: "grid-1",
      component: Applicationcompleted,
    },
    // Applicationcompleted
    // Conforminterview
    // ReadytoscheduleList
    // Interviewprofilelist
    // SchedulelistHandle

    // Scheduleinterview

    {
      path: `${appRoot}/profile`,
      // label: "Profile",
      icon: "grid-1",
      component: Profile,

    },
    {
      path: `${appRoot}/shortlisted`,
      component: Shortlisted
    },
    {
      path: `${appRoot}/konbon_dashboard`,
      component: konbonDasborad
    },
    {
      path: `${appRoot}/account_detailes`,
      component: Accountdetails
    },
    {
      path: `${appRoot}/Report/:interviewid`,
      component: Report
    },
    {
      path: `${appRoot}/videoTranscriber/:interviewid`,
      component: VideoTranscriber
    },

    // {
    //   path:`${appRoot}/Organization`,
    //   label: "Organization",
    //   icon: "grid-1",
    //   component:Organization,

    // },
    // {
    //   path: `${appRoot}/Organizationview`,
    //   component:OrganizationView
    // },
    // {
    //   path:`${appRoot}/Recruiter`,
    //   label: "Recruiter",
    //   icon: "grid-1",
    //   component:Recruiter,

    // },
    // {
    //   path:`${appRoot}/Integration`,
    //   label: "Integration",
    //   icon: "grid-1",
    //   component:Integration,

    // },
    // {
    //   path: `${appRoot}/Recruiterview`,
    //   component:Recruiterview
    // },

    // Accountdetails
    // /konbon_dashboard
    // konbonDasborad


    // InterviewScreen
    // DashboardAnalysis
  ],
};
export default routesAndMenuItems;
